import React from 'react'
import { StyleSheet } from 'react-native'

import { LeaderboardItem } from 'partials/Leaderboard/subcomponents/LeaderboardItem'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'

import { useSubscriptions } from 'hooks/useSubscriptions'

import { PartialUser } from 'types/user'

type SubscribedTrainersTabProps = {
  trainer: PartialUser
}

const styles = StyleSheet.create({
  flatList: { paddingTop: 20 },
})

export const SubscribedTrainersTab = ({ trainer }: SubscribedTrainersTabProps) => {
  const { data: subscriptions, isLoading } = useSubscriptions({
    trainerId: trainer.id,
  })

  const members = subscriptions?.map((member) => member.user)

  return (
    <Box flex={1} backgroundColor='white'>
      <FlatList<PartialUser>
        style={styles.flatList}
        data={members}
        keyExtractor={(user) => `${user.id}-trainer`}
        loading={isLoading}
        renderItem={({ item }) => {
          return <LeaderboardItem userId={item.id as string} />
        }}
        noContentProps={{
          message: 'You have no members in your Group yet.',
        }}
      />
    </Box>
  )
}
